import { gql } from '@apollo/client'

import { restInvoiceClient } from './clients.configuration'

const commonDeliveryNoteFragment = `
  id
  issueDate
  customer {
    companyName
    firstName
    lastName
    title
    customerType
  }
  documentType
  __typename
`

const lines = `
lines {
    ... on rowLine {type,date,description,quantity,netTotal,taxTotal,grossTotal,vatPct,unit,unitPrice,totalDiscount}
  }`

const deliveryNoteFields = `
{
  deliverynoteNumber
  invoiceNumber
  receiptNumber
  ${commonDeliveryNoteFragment}
  status {
    status
    events {
      createdAt,
      eventType
    }
  }
  ${lines}
}`

const DELIVERYNOTES_QUERY_SLIM = `
deliverynotes {
  company {
    tradeName {
      name
    }
  }
  deliverynoteNumber
  receiptNumber
  invoiceNumber
  status {
    status
  }
  ${commonDeliveryNoteFragment}
  ${lines}
}`

const deliveryNoteDraftFields = `
{
  deliverynoteNumber
  invoiceNumber
  receiptNumber
  ${commonDeliveryNoteFragment}
  ${lines}
}`

const DRAFT_DELIVERY_NOTES_QUERY_SLIM = `
deliverynoteDrafts {
  invoiceNumber
  ${commonDeliveryNoteFragment}
  ${lines}
}`

export const GET_ALL_DELIVERY_NOTES_QUERY = gql`{
  deliverynotes:
    ${DELIVERYNOTES_QUERY_SLIM}
  drafts:
    ${DRAFT_DELIVERY_NOTES_QUERY_SLIM}
}`

export const GET_DELIVERY_NOTE_BY_ID_QUERY = gql`
  query deliverynote($id: Int) {
    deliverynote(id: $id) ${deliveryNoteFields}
  }`

export const GET_DELIVERY_NOTE_DRAFT_BY_ID_QUERY = gql`
  query deliverynote($id: Int) {
    deliverynoteDraft(id: $id) ${deliveryNoteDraftFields}
  }`

export const refreshDeliveryNote = (id: number) => {
  return restInvoiceClient.query({
    query: GET_DELIVERY_NOTE_BY_ID_QUERY,
    variables: { id },
    fetchPolicy: 'network-only',
  })
}
